export default __webpack_public_path__ + "static/barry-icon-f42f4d5697637e0aa08c201e4c7cb765.png";